import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-car-city-popup',
  templateUrl: './car-city-popup.component.html',
  styleUrls: ['./car-city-popup.component.scss',],
})
export class CarCityPopupComponent implements OnInit {

  faTimes = faTimes;
  faMapMarkerAlt = faMapMarkerAlt;
  showCityPopup: boolean = false;
  selectedCity: string = '';

  constructor(private _activateRoute: ActivatedRoute) {
    this._activateRoute.queryParams.subscribe({
      next: (params) => {
        const cityName = params['city'];
        if (cityName) this.selectedCity = cityName;
        if (this.showCityPopup) this.toggleCity();
      },
    });
  }

  ngOnInit(): void {
    const cityName = localStorage.getItem(AppConstants.CURRENT_CITY_KEY);
    if (cityName) this.selectedCity = cityName;
  }

  toggleCity() {
    this.showCityPopup = !this.showCityPopup;
  }
}
